module.exports = __webpack_public_path__ + "img/yqgz.e54d482a.png";